import React from "react";
import Footer from "./sections/Footer";
// import Header2 from "./ui/Header2";
import ic_success from "./img/ic_success.svg"
import "./ThankYou.css";
import { Button } from "@mui/material";
function ThankYou() {
  return (
    <>
      {/* <Header2 /> */}
      {/* <Whitesections
        pent_img={[3, 4]}
        pent_size={[1, 0]}
        margin={["80px", "415px"]}
        id={""}
        background={"#EEF3FF"}
      > */}
        <div className="flex thanks">
          <img src={ic_success} alt="startick" />
          <h1>Thank you for requesting a Trial!</h1>
          <p>We will contact you shortly.</p>
          <Button
              sx={{
                px: "32px",
                py: "12px",
                // mr: {lg:'89px',md:"20px"},
                backgroundColor: "#003FB9",
                boxShadow: "0px 3px 6px #003FB929",
                borderRadius: "4px",
                opacity: "1",
                color: "#FFFFFF",
                textTransform: "none",
                font: {xs: "normal normal 600 16px/120% Poppins", sm: "normal normal 600 20px/120% Poppins"},
                ":hover": {
                  background: "#3659A7 0% 0% no-repeat padding-box",
                  boxShadow: "0px 3px 6px #003FB929",
                  borderRadius: "4px",
                },
                // mr:"10"
              }}
            >
              Ok, Got it
            </Button>
        </div>
      {/* </Whitesections> */}
      <Footer />
    </>
  );
}

export default ThankYou;
